import { useContext } from 'react';
import { KPIContext } from '../contexts/KPIContext';

export function useKPI() {
  const value = useContext(KPIContext);
  return value;
}
